export default __webpack_public_path__ + "static/media/YOOZ-PAYMENT-Gateway-banner.6abe86f7.png";